import Vue from 'vue'
// Components
//import '@/components'

// Plugins
import vuetify from './plugins/vuetify'

//import './plugins/axios'
import { sync } from 'vuex-router-sync'

import App from './App.vue'
import router from './router'
import store from '@/store'
//import config from '../config.dev';
import extractionsplugin from './plugins/extractions'
import StatusBox from './components/base/StatusBox'
import i18n from './i18n'

Vue.config.productionTip = false;
Vue.prototype.$config =config;

// Sync store with router
sync(store, router)

const plugin = {
  install () {
    Vue.extractions = extractionsplugin
    Vue.prototype.$extractions = extractionsplugin
  }
}

Vue.use(plugin)
Vue.component('status-box', StatusBox)

const vue = new Vue({
  store,
  router,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')

export default vue